const mEditionProductSalesLettersModalEditExternalSite = {
  mEditionProductSalesLettersModalEditExternalSite: {
    alerts: {
      updateProductoPaginaIdroop: {
        error: 'Un error ha ocurrido. Verifica los datos ingresados y vuelve a intentarlo.',
        success: 'La carta de venta fue editada exitosamente.'
      }
    },

    buttonCancel: 'CANCELAR',
    buttonPrimary: 'GUARDAR',

    inputs: {
      nombre: {
        label: 'Escribe aquí un nombre para la carta de venta',
        message: '* De 1 a 60 caracteres',
        placeholder: 'Mi Carta de Venta Externa'
      },

      url: {
        label: 'Escribe aquí la URL del enlace externo',
        placeholder: 'https://www.mi-carta-de-venta-externa.com'
      }
    },

    productUrlFormMessage: 'Para conectar tu carta de venta con nuestro sistema de inscripción, por favor inserta en el botón de compra de tu carta de venta el siguiente link para enlazarlo al formulario compra.',
    title: 'EDITAR CARTA',

    validation: {
      nombre: {
        maxLength: 'La longitud máxima permitida es de 60 caracteres.',
        minLength: 'La longitud mínima permitida es de 1 caracter.',
        required: 'Nombre de carta de venta es requerido.'
      },

      url: {
        required: 'Url externa de carta de venta es requerida.',
        url: 'La dirección de enlace externo debe ser url válida. '
      }
    }
  }
}

export default mEditionProductSalesLettersModalEditExternalSite
